module.exports = __webpack_public_path__ + "img/7.14983815.png";